import { FEATURES as features } from '../content/site'

export default function FeaturesSection() {
  return (
    <section
      id="features"
      className="relative py-[clamp(80px,12vh,160px)] bg-[#0d1117]"
    >
      <div
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage:
            'linear-gradient(rgba(6,182,212,1) 1px, transparent 1px), linear-gradient(90deg, rgba(6,182,212,1) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <div className="max-w-[1280px] mx-auto px-6 relative z-10">
        <div className="features-header text-center mb-16">
          <span className="text-xs font-mono uppercase tracking-[0.08em] text-[#06b6d4]">
            FEATURES
          </span>
          <h2 className="mt-4 text-[clamp(28px,3vw,42px)] font-semibold leading-[1.15] tracking-[-0.015em] text-white">
            Everything you need to win government work
          </h2>
          <p className="mt-4 text-[clamp(16px,1.5vw,20px)] leading-[1.6] text-[#9ca3af] max-w-[600px] mx-auto">
            Built specifically for New England trade contractors who want to stop chasing bids and start winning them.
          </p>
        </div>

        <div className="features-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => {
            const Icon = feature.icon
            return (
              <div
                key={feature.title}
                className="feature-card group bg-white/[0.03] border border-white/[0.06] rounded-xl p-8 transition-all duration-300 hover:border-[#06b6d4]/30 hover:shadow-[0_8px_32px_rgba(0,0,0,0.4),0_0_0_1px_rgba(6,182,212,0.15)] hover:-translate-y-1"
              >
                <div className="w-10 h-10 flex items-center justify-center">
                  <Icon size={28} className="text-[#06b6d4]" />
                </div>
                <h3 className="mt-5 text-[clamp(18px,2vw,22px)] font-semibold text-white leading-[1.3]">
                  {feature.title}
                </h3>
                <p className="mt-2 text-sm leading-[1.5] text-[#9ca3af]">
                  {feature.desc}
                </p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
